module.exports = __webpack_public_path__ + "img/main.16a4f6d2.png";